<div class="error-container" aria-live="assertive">
  <div class="alert valign-children-middle" *ngIf="errorFlag">
    <div class="alert-error" aria-label="Alert.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2 *ngIf='errorFlag'>You don't have any active licensed products.</h2>
	   <p *ngIf='errorFlag'><a href="javascript:void(0)"  routerLink="/browse" routerLinkActive="active"  >Shop now</a> to add new products.</p>
      <h2 *ngIf='!errorFlag'>Error!</h2>
      <p>{{ this.errorMessage }}</p>
    </div>
  </div>
</div>
<div class="row" *ngIf="actionAssignUnassign && !errorMessage">

      <div class="col-sm-12 col-md-6 col-md-offset-3">
            <h2>Select an action</h2>
            <form [formGroup]="actionForm" autocomplete="off">
                  <div class="row">
                        <div class="col-sm-12 col-md-12">
                              <label class="radio">
            <input type="radio" id="assignId"
               formControlName="userAction" value="ASSIGN" name="userAction">
            <i class="skin"></i>
            <span >Assign user licenses</span>
            </label>
                              <div *ngIf="actionForm.controls['userAction'].value === 'ASSIGN'">
                                    <div class="user-information">
                                          <p class="mar-bot-null"> Need to add users? </p>
                                          <p> <a href="javascript:void(0)" (click)="goToAddUserPage()">Create a single user</a> |
                                                <a href="javascript:void(0)" (click)="goToBulkUpload()">Add multiple users</a>
                                          </p>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-sm-12 col-md-12">
                              <label class="radio mar-bot-null">
            <input type="radio" id="unAssignId" formControlName="userAction" value="UNASSIGN" name="userAction">
            <i class="skin"></i>
            <span >Un-assign licenses</span>
            </label>
                        </div>
                  </div>
                  <hr class="bottom-hr" />
                  <div class="line-footer text-right">
                        <button type="button" aria-label="Continue." class="btn btn-secondary btn-sm-block pull-right" (click)="goToNextStep(this.actionForm.controls['userAction'].value)">Continue</button>
                        <a href="javascript:void(0)" class="btn btn-link btn-sm-block" (click)="cancel()">Cancel</a>
                  </div>
            </form>
      </div>
</div>